import { User } from 'Classes';
import {
   useState,
   useEffect,
   useContext,
   createContext,
   type Dispatch,
   type SetStateAction,
   type PropsWithChildren,
} from 'react';

interface UserAuthContext{
   user: User;
   setUser: Dispatch<SetStateAction<User>>;
   logout: () => void;
}

const UserContext=createContext({} as UserAuthContext);

export var useUser=()=>useContext(UserContext);

export var UserProvider=(props: PropsWithChildren)=>{
   var [user, setUser] = useState<User>(JSON.parse(localStorage.getItem('user')) || null);

   var onLogout=()=>{
      localStorage.clear();
      setUser(null);
   };

   useEffect(()=>{
      localStorage.setItem('user', JSON.stringify(user));
   },[user])

   return(
      <UserContext.Provider
         value={{
            user,
            setUser,
            logout: onLogout,
         }}
      >
         {props.children}
      </UserContext.Provider>
   );
};
